import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  title: Yup.string().required('Required'),
  reward: Yup.string().required('Required'),
  emailSubject: Yup.string().required('Required'),
  emailBody: Yup.string().required('Required'),
  emailSms: Yup.string().required('Required'),
  ctaText: Yup.string().required('Required'),
  bannerText: Yup.string().required('Required'),
  pitchMessage: Yup.string().required('Required'),
  residentEnrollHeader: Yup.string().required('Required'),
  residentEnrollFooter: Yup.string().required('Required'),
  residentInviteEmailSubject: Yup.string().required('Required'),
  residentInviteEmailBody: Yup.string().required('Required'),
  residentInviteSms: Yup.string().required('Required'),
  tourCtaText: Yup.string().required('Required'),
  tourCtaUrl: Yup.string().required('Required'),
  contactCtaText: Yup.string().required('Required'),
  contactCtaUrl: Yup.string().required('Required'),
  residentDiscountEmailSubject: Yup.string().required('Required'),
  residentDiscountEmailBody: Yup.string().required('Required'),
  residentDiscountEmailSms: Yup.string().required('Required'),
  friendInviteMenuBody: Yup.string().required('Required'),
  popupTitle: Yup.string().required('Required'),
  popupMessage: Yup.string().required('Required'),
  residentBannerTitle: Yup.string().required('Required'),
  landingPageContent: Yup.string().required('Required'),
  landingPageTitle: Yup.string().required('Required')
});